import {Controller} from '@hotwired/stimulus';
import {useWindowResize} from 'stimulus-use'

import Carousel from "bootstrap/js/dist/carousel";
import Collapse from "bootstrap/js/dist/collapse";
// import '../styles/components/criminal-sections.scss'

export default class extends Controller {
    connect() {
        super.connect();

        useWindowResize(this);
        this.init();
        // window.removeEventListener('resize', this.resize());
        // window.addEventListener('resize', this.resize());
        // window.onresize = this.init();


        this.element.querySelectorAll('.ci').forEach(function (item) {
            item.addEventListener('shown.bs.collapse', function () {

                // var itemHeight = this.scrollHeight;
                let headerHeight = document.getElementById('header').offsetHeight;
                let itemDistanceFromScreenTop = this.getBoundingClientRect().top;
                let windowScrollY = window.scrollY;

                // if (itemDistanceFromScreenTop < headerHeight + 16) {
                //   window.scrollTo({
                //     top: windowScrollY + itemDistanceFromScreenTop - headerHeight - 16,
                //     behavior: 'smooth'
                //   });
                // }

                // window.scrollTo({
                //     top: windowScrollY + Math.abs(itemDistanceFromScreenTop) - headerHeight - 16,
                //     behavior: 'smooth'
                // });

                // console.log(windowScrollY + itemDistanceFromScreenTop - headerHeight - 16);

                // console.log('itemHeight: ' + itemHeight);
                // console.log('innerheight of window: ' + window.innerHeight);
                // console.log('this.offsetTop: ' + this.offsetTop);
                // console.log('this.getBoundingClientRect().top: ' + this.getBoundingClientRect().top);
                // console.log('window.scrollY: ' + window.scrollY);


                // window.scrollTo({
                //   top: 0,
                //   behavior: 'smooth'
                // });

            });
        });
    }

    windowResize({width, height, event}) {

        let collapseElementList = this.element.querySelectorAll('.ci');
        let currentBreakpoint = bootstrapDetectBreakpoint();
        let inSidebar = document.querySelector('.side-bar #stages-of-criminal-proceedings');

        if (currentBreakpoint.index > 2 && !inSidebar) {
            collapseElementList.forEach((cItem) => {
                cItem.classList.remove('_carousel-item');
                cItem.classList.add('carousel-item');
                cItem.classList.remove('collapse');
            })
        } else {

            collapseElementList.forEach((cItem) => {
                cItem.classList.remove('carousel-item');
                cItem.classList.add('_carousel-item');
                cItem.classList.add('collapse');
            })
        }
    }

    reset() {
        // const criminalCarouselElement = document.querySelector('#criminalCarousel')

        let element = document.querySelector('[data-controller="criminal-section"]');

        // element.replaceWith(element.cloneNode(true))
        // console.log(element)
        // element.setAttribute('data-controller', '');
        // setTimeout(() => {
        // element.setAttribute('data-controller', 'criminal-section');
        // }, 1000)

        // this.recreateNode(this.element)
    }

    recreateNode(el, withChildren) {
        if (withChildren) {
            el.parentNode.replaceChild(el.cloneNode(true), el);
        } else {
            let newEl = el.cloneNode(false);
            while (el.hasChildNodes()) newEl.appendChild(el.firstChild);
            el.parentNode.replaceChild(newEl, el);
        }
    }

    init() {


        let collapseElementList = this.element.querySelectorAll('.ci');


        // let currentBreakpoint = bootstrapDetectBreakpoint();
        // if (currentBreakpoint.index > 2) {
        const criminalCarouselElement = document.querySelector('#criminalCarousel')
        const carousel = new Carousel(criminalCarouselElement)

        this.element.querySelectorAll('.criminalSvg').forEach((svgItem, index) => {
            svgItem.addEventListener('click', (event) => {
                carousel.to(index);
            })
        })
        // criminalCarouselElement.getEventListeners()['slide.bs.carousel'].forEach(e => e.remove());
        const svgItems = Array.from(this.element.querySelectorAll('.criminalSvg'));
        criminalCarouselElement.addEventListener('slide.bs.carousel', (event) => {
            svgItems.forEach((svgItem) => svgItem.classList.remove('active'));
            const target = svgItems[event.to];
            target.classList.add('active');
            const color = target.querySelector('path').style.stroke;
            event.relatedTarget.style.setProperty('--item-bg', color);
        })
        // } else {


        let collapseList = [...collapseElementList].map(collapseEl => new Collapse(collapseEl, {
            toggle: false,
            parent: document.querySelector('.carousel-inner')
        }))
        let accHeaders = document.querySelectorAll('.accHeader');

        collapseList.forEach((item, index) => {
            item._element.addEventListener('show.bs.collapse', () => {
                if (index + 1 < accHeaders.length) {
                    accHeaders[index + 1].querySelector('path:nth-child(3)').style.display = "none";
                    accHeaders[index + 1].querySelector('polygon').style.display = "none";
                }
            })
            item._element.addEventListener('hide.bs.collapse', () => {
                document.querySelectorAll('.accHeader path:nth-child(3)').forEach((it) => {
                    it.style.display = "block";
                });
                document.querySelectorAll('.accHeader polygon').forEach((it) => {
                    it.style.display = "block";
                });
            })
        })


        accHeaders.forEach((item, index) => {
            let color = item.querySelector('path').style.stroke;
            collapseList[index]._element.style.setProperty('--item-bg', color)
            item.addEventListener('click', (event) => {
                let x = collapseList[index].toggle();
            })
        })
    }
}


const bootstrapDetectBreakpoint = function () {
    // cache some values on first call
    let breakpointValues = [];
    let breakpointNames = ["xxl", "xl", "lg", "md", "sm", "xs"]


    const isPriorBS5 = !!window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-sm')
    const prefix = isPriorBS5 ? "--breakpoint-" : "--bs-breakpoint-"
    for (const breakpointName of breakpointNames) {
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(prefix + breakpointName)
        if (value) {
            breakpointValues[breakpointName] = value
        }
    }
    let i = breakpointNames.length
    for (const breakpointName of breakpointNames) {
        i--
        if (window.matchMedia("(min-width: " + breakpointValues[breakpointName] + ")").matches) {
            return {name: breakpointName, index: i}
        }
    }
    return null
}
